module.exports = __webpack_public_path__ + "assets/img/two_phone.4c9d7108.png";